import firebase from "firebase/app";
import "firebase/storage";

// for some apparent reason typings from tinyMCE aren't available

interface BlobInfo {
    id: () => string;
    name: () => string;
    filename: () => string;
    blob: () => Blob;
    base64: () => string;
    blobUri: () => string;
    uri: () => string | undefined;
}

const tinyMCEImageUpload = (
    blobInfo: BlobInfo,
    success: (url: string) => void,
    failure: (err: string, options?: { remove?: boolean }) => void,
    progress?: (percent: number) => void
): void => {
    const storage = firebase.storage().ref();
    const uploadTask = storage
        .child("images-texteditor")
        .child(Date.now().toString())
        .put(blobInfo.blob());
    uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            const progressValue =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100 || 0;
            if (progress) progress(progressValue);
            switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                    break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                    break;
            }
        },
        (error) => {
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            // eslint-disable-next-line default-case
            switch (error.code) {
                case "storage/unauthorized":
                    failure(
                        `User doesn't have permission to access the object`
                    );
                    break;

                case "storage/canceled":
                    failure(`User canceled the upload`);
                    break;

                case "storage/unknown":
                    failure(
                        `Unknown error occurred, inspect error.serverResponse`
                    );
                    break;
            }
        },
        () => {
            // Upload completed successfully, now we can get the download URL
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                success(downloadURL);
            });
        }
    );
};

export default tinyMCEImageUpload;
